import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { TranslateModule } from '@ngx-translate/core';
import { TimeFieldsComponent, MovilityFieldComponent, LocationFieldComponent } from "src/app/pages/register-user/shared/components";

@Component({
  selector: 'app-form-step-2',
  standalone: true,
  imports: [
    TranslateModule,
    TimeFieldsComponent,
    MovilityFieldComponent,
    LocationFieldComponent
],
  templateUrl: './form-step-2.component.html',
  styleUrls: ['./form-step-2.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class FormStep2Component {
  public form = input<FormGroup>();
}
